<template>
    <div>
        <!-- 面包屑导航 -->
        <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>数据中心</el-breadcrumb-item>
        </el-breadcrumb> -->
        <h3>
            今日数据
        </h3>

        <div class="data_box">
            <el-row :gutter="20">
                <el-col :span="6" v-for=" (val, key) in listData" :key="key">
                    <div style="margin: 20px;" v-if="text[key]">
                        <el-statistic :title="text[key]">
                            <template slot="formatter">
                                {{val}}
                            </template>
                        </el-statistic>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
    
<script>
import { todayList } from '../../api/userMG'
export default {
    data() {
        return {
            loading: false,
            listData:null,
            text:{
                userCount:'注册人数',
                // usdt_In:'转入的USDT',
                usdt_Out:'转出的USDT',
                // eth_In:'转入的ETH',
                // eth_Out:'转出的ETH',
                minerTotal:'购买矿机总额U',
                lockTotal:'锁仓数', 
                totalDet:'游戏投注G',
                totalWin:'游戏盈利M',
                // totalWin2:'游戏盈利H',
                totalRelease:'挖矿数G',
                totalBack:'游戏返还G',
                winRate:"游戏拨出比例"
            }
        }
    },
    // 挂载结束状态(里面是操作)
    mounted() {
        this.getpay()
    },
    methods: {
        getpay() {
            this.loading = true
            todayList()
                .then(res => {
                    this.loading = false
                    if (res.code != 0) {
                        this.$message({
                            type: 'info',
                            message: res.message
                        })
                    } else {
                        this.listData = res.data
                    }
                })
                .catch(err => {
                    this.loading = false
                    this.$message.error('列表加载失败，请稍后再试！')
                })
            // this.chart = echarts.init(this.$refs.payEchart)
            // this.chart.setOption(this.payoption)
        },
    }
}

</script>
    
<style>
.data_box{
    margin-top: 30px;
    border-radius: 10px;
    border: 1px solid #e4ebed;
    padding: 20px;
    border-radius: 6px;
    background-color: #fafcff;
}
.text-c {
    text-align: center;
}

.cavasbox {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
}

.paybox {
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    border-radius: 5px;
    margin-top: 20px;
    height: 500px;
}
</style>


// WEBPACK FOOTER //
// src/views/data/Overview.vue